let postalCodesEastOfHwy146 = [];

export default {
    'isEastOfHwy146Required_ENT': (territoryCode, postalCode) => ((territoryCode === '1') && (postalCodesEastOfHwy146 && postalCode && postalCodesEastOfHwy146.includes(postalCode.substring(0, 5)))),
    'isEastOfHwy146Rquired': (territoryCode, postalCode) => ((territoryCode === '1') && (postalCodesEastOfHwy146 && postalCode && postalCodesEastOfHwy146.includes(postalCode.substring(0, 5)))),
    'setPostalCodesEastOfHwy146': (codes) => {
        postalCodesEastOfHwy146 = codes;
    }
};
